<template>
  <v-btn
    :input-value="active"
    depressed
    class="ml-2 mt-2"
    active-class="primary white--text"
    @click="$emit('toggle', $event)"
  >
    <v-icon v-if="icon" left v-text="icon" />
    {{ paymentMethod.name }}
  </v-btn>
</template>

<script>
  import PaymentMethodType from '@/Models/Static/PaymentMethod'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      paymentMethod: {
        required: true,
        type: Object,
      },
      active: {
        required: true,
        type: Boolean,
      },
    },

    data: () => ({
      PaymentMethodType,
    }),

    computed: {
      icon () {
        if (this.PaymentMethodType.isCard(this.paymentMethod.id)) {
          return this.icons.creditCard
        }
        if (this.PaymentMethodType.isCash(this.paymentMethod.id)) {
          return this.icons.cash
        }
        return null
      },
    },
  }
</script>
